import React, { useEffect, useState } from "react";
import {
  ADD_DOCOTR,
  API_BASE_URL,
  directToken,
  LIST_OF_CITY,
  LIST_OF_HOSPITAL,
  LIST_OF_SPECIALITY,
} from "../services/end_points";
import axios from "axios";
import { Alert, Button, Col, Form, Input, Row, Select, Typography } from "antd";
import dayjs from "dayjs";
const AddDoctor = ({ updateUserList }) => {
  const [specialityOption, setSpecialityOption] = useState([]);
  const [cityOption, setCityOption] = useState([]);
  const [areaOption, setAreaOption] = useState([]);
  const [hospitalOption, setHospitalOption] = useState([]);
  const [filterHospitals, setFilterHospitals] = useState([]);
  const [isDateInput, setIsDateInput] = useState(false);
  const [alert, setAlert] = useState(false);
  const userId = localStorage.getItem("userid");
  const [formData, setFormData] = useState({
    doctorName: "",
    dof: "",
    speciality: "",
    hospitalName: "",
    city: "",
    area: "",
    charges: "",
  });
  const handleReset = () => {
    setFormData({
      doctorName: "",
      dof: "",
      speciality: "",
      hospitalName: "",
      city: "",
      area: "",
      charges: "",
    });
  };
  const updateHospitalAndArea = async (specialityId) => {
    const selectedSpeciality = specialityOption.find(
      (s) => s.value === specialityId
    );
    if (selectedSpeciality) {
      const associatedHospitalIds = specialityOption
        .filter((s) => s.value === specialityId)
        .map((s) => s.hospitalId);

      const filteredHospitals = hospitalOption.filter((hospital) =>
        associatedHospitalIds.includes(hospital.hospitalId)
      );

      setFilterHospitals(
        filteredHospitals.length > 0
          ? filteredHospitals.map((hospital) => ({
              label: hospital.hospitalName,
              value: hospital.hospitalId,
            }))
          : []
      );

      if (filteredHospitals.length > 0) {
        const defaultHospitalId = filteredHospitals[0].value;
        setFormData((prevData) => ({
          ...prevData,
          hospitalName: defaultHospitalId,
          area: "",
          city: "",
        }));
        await fetchAreasByHospital(defaultHospitalId);
      }
    } else {
      setFilterHospitals([]);
      setFormData((prevData) => ({
        ...prevData,
        hospitalName: "",
        area: "",
        city: "",
      }));
    }
  };

  const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");
  const handleFormChange = async (name, value) => {
    if (name === "speciality") {
      setFormData((prevData) => ({
        ...prevData,
        speciality: value,
        hospitalName: "",
        area: "",
        city: "",
      }));
      await updateHospitalAndArea(value);
    } else if (name === "hospitalName") {
      setFormData((prevData) => ({
        ...prevData,
        hospitalName: value,
        area: "",
        city: "",
      }));
      await fetchAreasByHospital(value);
    } else if (name === "area") {
      const selectedArea = areaOption.find((area) => area.value === value);
      const locationId = selectedArea ? selectedArea.locationId : "";
      setFormData((prevData) => ({
        ...prevData,
        area: value,
        city: "",
      }));
      await fetchCitiesByArea(locationId);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const fetchAreasByHospital = async (hospitalId) => {
    try {
      if (!hospitalId) {
        setAreaOption([]);
        setCityOption([]);
        return;
      }
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(
        `${API_BASE_URL}/location/area-list?hospitalId=${hospitalId}`,
        { headers }
      );
      const data = await response.json();

      const filteredAreas = data.list.filter(
        (area) => area.hospitalId === parseInt(hospitalId)
      );

      setAreaOption(
        filteredAreas.map((source) => ({
          label: source.area,
          value: source.id,
          locationId: source.locationId,
        }))
      );

      if (filteredAreas.length > 0) {
        setFormData((prevData) => ({
          ...prevData,
          area: filteredAreas[0].id,
        }));
        await fetchCitiesByArea(filteredAreas[0].locationId);
      } else {
        setFormData((prevData) => ({
          ...prevData,
          area: "",
          city: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching areas:", error);
      setAreaOption([]);
      setCityOption([]);
    }
  };

  const fetchCitiesByArea = async (locationId) => {
    try {
      if (!locationId) {
        setCityOption([]);
        return;
      }

      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(
        `${API_BASE_URL}/location/city-list?locationId=${locationId}`,
        { headers }
      );
      const data = await response.json();
      const filteredCities = data.list.filter((city) => city.id === locationId);
      setCityOption(
        filteredCities.map((source) => ({
          label: source.city,
          value: source.id,
        }))
      );

      if (filteredCities.length > 0) {
        setFormData((prevData) => ({
          ...prevData,
          city: filteredCities[0].id,
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          city: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      setCityOption([]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${API_BASE_URL}${ADD_DOCOTR}`, formData)
      .then((res) => {
        setFormData({
          doctorName: "",
          dof: "",
          speciality: "",
          hospitalName: "",
          city: "",
          area: "",
          charges: "",
        });
        updateUserList(res.data);
        if (res.status === 201) {
          setAlert(true);
        }
      })
      .catch((err) => {
        console.error("Error details:", err);
        setAlert(false);
      });
  };

  const getCity = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(`${API_BASE_URL}${LIST_OF_CITY}`, {
        headers,
      });
      const data = await response.json();

      setCityOption(
        data.list.map((source) => ({ label: source.city, value: source.id }))
      );
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const getSpeciality = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };

      const response = await fetch(
        `${API_BASE_URL}${LIST_OF_SPECIALITY}/${userId}`,
        { headers }
      );
      const data = await response.json();
      setSpecialityOption(
        data.list.map((source) => ({
          label: source.specialities_names,
          value: source.specialityId,
          hospitalId: source.hospitalId,
        }))
      );
    } catch (error) {
      console.error("Error fetching specialities:", error);
    }
  };

  const getHospital = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(
        `${API_BASE_URL}${LIST_OF_HOSPITAL}/${userId}`,
        { headers }
      );

      const data = await response.json();
      setHospitalOption(
        data.list.map((hospital) => ({
          hospitalId: hospital.id,
          hospitalName: hospital.hospitalName,
        }))
      );
    } catch (error) {
      console.error("Error fetching hospitals:", error);
    }
  };

  useEffect(() => {
    getSpeciality();
    getCity();
    getHospital();
  }, []);

  const handleFocus = () => setIsDateInput(true);
  const handleBlur = (e) => {
    if (!e.target.value) setIsDateInput(false);
  };
  return (
    <Form layout="vertical">
      {alert && (
        <div marginBottom="20px">
          <Alert
            type="success"
            style={{
              backgroundColor: "#dff0d8",
              color: "green",
              fontSize: "16px",
              borderColor: "#dff0d8",
              textAlign: "center",
            }}
            message={"Doctor Created!"}
          />
        </div>
      )}
      <Row style={{ gap: "10px" }}>
        <Col xl={8} lg={8} md={6} sm={24} xs={24}>
          <div>
            <Form.Item label="Doctor Name" labelAlign="top" required>
              <Input
                style={{
                  marginTop: "2px",
                  width: "100%",
                  height: "40px",
                }}
                name="doctorName"
                value={formData.doctorName}
                onChange={(e) =>
                  handleFormChange(e.target.name, e.target.value)
                }
              />
            </Form.Item>
          </div>
        </Col>
        <Col xl={8} lg={8} md={7} sm={24} xs={24}>
          <div>
            <Form.Item label="D.O.B" required>
              <Input
                style={{
                  marginTop: "2px",
                  width: "100%",
                  height: "40px",
                }}
                type={isDateInput ? "date" : "text"}
                name="dof"
                value={formData.dof}
                onChange={(e) =>
                  handleFormChange(e.target.name, e.target.value)
                }
                onFocus={() => setIsDateInput(true)}
                onBlur={(e) => {
                  if (!e.target.value) setIsDateInput(false);
                }}
                inputProps={{
                  max: yesterday,
                }}
              />
            </Form.Item>
          </div>
        </Col>
        <Col xl={7} lg={7} md={6} sm={24} xs={24}>
          <div>
            <Form.Item label=" Select Speciality" required>
              <Select
                style={{
                  marginTop: "2px",
                  fontSize: "14px",
                  width: "100%",
                  height: "40px",
                }}
                showSearch
                name="speciality"
                value={formData.speciality || undefined}
                onChange={(value) => handleFormChange("speciality", value)}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                dropdownRender={(menu) => <div>{menu}</div>}
                options={specialityOption}
              />
            </Form.Item>
          </div>
        </Col>
      </Row>

      <Row
        style={{
          gap: "10px",
          marginTop: "1.5rem",
        }}
      >
        <Col xl={8} lg={8} md={6} sm={24} xs={24}>
          <Form.Item label="Select Hospital" required>
            <div>
              <Select
                showSearch
                style={{
                  marginTop: "2px",
                  fontSize: "14px",
                  width: "100%",
                  height: "40px",
                }}
                name="hospitalName"
                value={formData.hospitalName || undefined}
                onChange={(value) => handleFormChange("hospitalName", value)}
                options={filterHospitals}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                dropdownRender={(menu) => (
                  <div style={{ maxHeight: "80px", overflowY: "auto" }}>
                    {menu}
                  </div>
                )}
              />
            </div>
          </Form.Item>
        </Col>
        <Col xl={8} lg={8} md={7} sm={24} xs={24}>
          <Form.Item label="Select Area" required>
            <div>
              <Select
                showSearch
                style={{
                  marginTop: "2px",
                  fontSize: "14px",
                  width: "100%",
                  height: "40px",
                }}
                name="area"
                value={formData.area || undefined}
                onChange={(value) => handleFormChange("area", value)}
                options={areaOption}
              />
            </div>
          </Form.Item>
        </Col>
        <Col xl={7} lg={7} md={6} sm={24} xs={24}>
          <Form.Item label="Select City" required>
            <div>
              <Select
                showSearch
                style={{
                  marginTop: "2px",
                  fontSize: "14px",
                  width: "100%",
                  height: "40px",
                }}
                name="city"
                value={formData.city || undefined}
                onChange={(value) => handleFormChange("city", value)}
                options={cityOption}
              />
            </div>
          </Form.Item>
        </Col>
      </Row>
      <Row
        style={{
          gap: "10px",
          marginTop: "1.5rem",
        }}
      >
        <Col xl={8} lg={8} md={6} sm={24} xs={24}>
          <Form.Item label="Charges" labelAlign="top" required>
            <Input
              style={{
                marginTop: "2px",
                width: "100%",
                height: "40px",
              }}
              name="charges"
              value={formData.charges}
              onChange={(e) => handleFormChange(e.target.name, e.target.value)}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xl={24} lg={24} sm={24} md={24}>
          <div style={{ display: "flex", marginTop: "1.5rem" }}>
            <Button
              type="button"
              onClick={handleReset}
              style={{
                color: "black",
                // border: "solid #1236fa",
                border: "solid #1236faba",
                marginRight: "auto",
                width: "80px",
                borderRadius: "12px",
              }}
            >
              Reset
            </Button>
            <Button
              type="submit"
              onClick={handleSubmit}
              style={{
                color: "white",
                // background: "#1236fa",
                background: "#1236faba",
                width: "80px",
                borderRadius: "12px",
              }}
            >
              Submit
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
};
export default AddDoctor;
